export enum TransportMode {
  Unknown = 0,
  Road = 1,
  Rail = 2,
  Sea = 3,
  Air = 4,
}
